import React, { useRef, useState } from "react"
import { Bubble, Dropdown, List, SearchBox } from "tea-component"
import { useIntl } from "umi"
import './index.scss'
import useSearch from "@/pages/dashboard/components/SelectorMultiple/hooks/useSearch"

const StepSelect = (props: any) => {
  const { options, stepValue, onChange } = props
  const { formatMessage } = useIntl()
  const {
    searchValue,
    setSearchValue,
    replaceMatch,
    buildHighLightData,
    handleSearchValueChange,
  } = useSearch(options);

  const selectedTextRef = useRef(null)
  const selectedText = options?.find((v: any) => v?.value === stepValue)?.text || stepValue
  const bubbleText = (selectedTextRef?.current?.clientWidth < selectedTextRef?.current?.scrollWidth
    || selectedTextRef?.current?.clientHeight < selectedTextRef?.current?.scrollHeight) ? selectedText : null

  const searchOptions = buildHighLightData() ?? [];

  return <Bubble
    trigger="hover"
    dark
    placement="top"
    content={bubbleText}
  >
    <Dropdown
      className="dbd-step-select"
      boxClassName="dbd-step-select-dropdown"
      appearance="button"
      matchButtonWidth
      clickClose={false}
      onClose={() => {
        setSearchValue('')
      }}
      button={
        <div className="select-button">
          <div className="select-button-text">{formatMessage({ id: 'funnel_step' })}</div>
          <div ref={selectedTextRef} className="select-button-value">{selectedText}</div>
        </div>
      }
      footer={<div className="dbd-step-select-footer">
        <span className="dbd-step-select-footer-icon">*</span>
        {formatMessage({ id: 'funnel_inevitable_step' })}
      </div>
      }
    >
      {close => (
        <>
          <SearchBox
            placeholder={formatMessage({ id: 'selector_multiple_component_placeholder' })}
            className="selector-multiple-search-input"
            onChange={handleSearchValueChange}
            value={searchValue}
          />
          {
            searchValue ? <List type="option">
              {
                searchOptions?.length > 0 ?
                  searchOptions?.map((item: any) => {
                    return <List.Item
                      className={stepValue === item?.value ? 'is-selected' : ''}
                      onClick={() => {
                        onChange?.(item?.value)
                        close?.()
                      }}>
                      <span
                        dangerouslySetInnerHTML={{ __html: `${item?.text}` }}
                      />
                      {item?.default && <span className="dbd-step-select-dropdown-icon">*</span>}
                    </List.Item>
                  }) :
                  <div className="dbd-step-select-dropdown-nodata">{formatMessage({ id: 'selector_multiple_component_no_data' })}</div>
              }
            </List> :
              <List type="option">
                {
                  options?.map((item: any) => {
                    return <List.Item
                      className={stepValue === item?.value ? 'is-selected' : ''}
                      onClick={() => {
                        onChange?.(item?.value)
                        close?.()
                      }}>
                      {item?.text}
                      {item?.default && <span className="dbd-step-select-dropdown-icon">*</span>}
                    </List.Item>
                  })
                }
              </List>
          }
        </>
      )}
    </Dropdown>
  </Bubble>
}

export default StepSelect